import { getLevelNIA as r } from "../level-metrics/index25.js";
import { getLevelArrayMetric as t } from "../index4.js";
const A = (e) => t(e, r);
export {
  A as getLevelArrayNIA
};
//# sourceMappingURL=index11.js.map
